import {
  isDocRef,
  isObject,
  type DocumentReference,
} from '@principle-theorem/shared';
import { IMarketingCampaignStep } from '../marketing/campaign-step';
import { type IInvoice } from './invoice';

export interface IPatientViewInvoiceTokenData {
  invoice: DocumentReference<IInvoice>;
  campaignStepSource?: DocumentReference<IMarketingCampaignStep>;
}

export interface IPatientViewInvoiceRequest {
  tokenUid: string;
}

export function isPatientViewInvoiceTokenData(
  data: unknown
): data is IPatientViewInvoiceTokenData {
  return isObject(data) && isDocRef(data.invoice);
}
